if (!customElements.get('load-more-list')) {
  customElements.define(
    'load-more-list',
    class LoadMoreList extends window.BAO.CustomElement {
      currentPage = 1

      setupListeners () {
        if (window.BAO.utils.getElement(`[data-load-more-list-el="trigger"]`)) {
          this.onTriggerClick = this.onTriggerClick.bind(this)

          this.listeners.add(
            this.els.trigger.element,
            'click',
            this.onTriggerClick,
          )
        }
      }

      async onTriggerClick () {
        this.loading = true

        // eslint-disable-next-line compat/compat
        const queries = new URLSearchParams(window.location.search)
        queries.set('page', (this.currentPage += 1).toString())
        queries.set('sections', this.options.sectionId)

        const sectionHTML = await this.fetchSection(queries.toString())
        const newSectionDOM = new DOMParser().parseFromString(
          sectionHTML,
          'text/html',
        )

        this.appendNewItemsToTarget(newSectionDOM)

        this.loading = false
      }

      fetchSection (queryString) {
        return fetch(`${this.options.url}/?${queryString}`)
          .then(res => res.json())
          .then(res => res[this.options.sectionId])
      }

      appendNewItemsToTarget (DOM) {
        const fragment = document.createDocumentFragment()
        const newItems = window.BAO.utils.getElements(
          this.options.itemClassName,
          { context: DOM },
        )
        newItems.forEach(item => fragment.appendChild(item))

        this.els.target.element.appendChild(fragment)

        if (this.currentItemCount !== this.options.totalItems) {
          this.setCurrentAmountViewed()
        } else {
          this.els.pagination.element.remove()
        }
      }

      setCurrentAmountViewed () {
        this.els.current.element.textContent = this.currentItemCount

        const progress = (this.currentItemCount / this.options.totalItems) * 100
        this.els.bar.element.style.setProperty(
          '--Transform_Progress',
          `-${100 - progress}%`,
        )
      }

      get loading () {
        return this._loading
      }

      set loading (val) {
        this._loading = val

        this.setAttribute('loading', val.toString())
      }

      get currentItemCount () {
        return window.BAO.utils.getElements(this.options.itemClassName, {
          context: this,
        }).length
      }

      get options () {
        return {
          itemClassName: this.getAttribute('item-class-name'),
          perPage: parseInt(this.getAttribute('per-page'), 10),
          currentPage: parseInt(this.getAttribute('current-page'), 10),
          totalItems: parseInt(this.getAttribute('total-items'), 10),
          sectionId: this.getAttribute('section-id'),
          url: this.getAttribute('url') || '',
        }
      }
    },
  )
}
